import { createContext } from 'react';

export interface ServiceCard {
  slug: string;
  name: string;
  path_id: string;
  card: string;
  starting_price: number | null;
  /** null = unknown (stats unavailable); 0 = genuinely no clinics. */
  clinic_count: number | null;
}

export interface Emergency {
  level: string;
  headline: string;
  body: string;
  actions: { type: string; label: string; value: string }[];
}

export type ChatCta = 'contact' | 'consultation' | 'history';
const CHAT_CTAS: readonly ChatCta[] = ['contact', 'consultation', 'history'];
/** The server names the next step; anything this build does not know is dropped, never rendered. */
export function knownCta(value: unknown): ChatCta | null {
  return typeof value === 'string' && (CHAT_CTAS as readonly string[]).includes(value) ? (value as ChatCta) : null;
}

export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  text: string;
  services?: ServiceCard[];
  /** Tappable answers to a clarifying question. Typing stays available. */
  options?: string[];
  disclaimer?: string;
  emergency?: Emergency | null;
  /** A next step the server attached: talk to the team, book a consultation,
   *  or open the person's own bookings. Rendered as one button. */
  cta?: ChatCta | null;
  status: 'streaming' | 'done' | 'stopped' | 'error';
}

export interface ChatState {
  open: boolean;
  messages: ChatMessage[];
  sessionId: string | null;
  streaming: boolean;
  wall: { message: string; loginRequired: boolean } | null;
  draft: string;
}

export interface ChatContextValue extends ChatState {
  openChat: (opts?: { seed?: string; context?: Record<string, unknown> }) => void;
  close: () => void;
  setDraft: (v: string) => void;
  send: (text: string) => void;
  stop: () => void;
  reset: () => void;
}

export const ChatContext = createContext<ChatContextValue | null>(null);
